import ContractingFooter from "features/contracting/components/ContractingFooter";
import ContractingStepFormProps from "features/contracting/models/ContractingStepFormProps";
import { useContractingStep } from "features/contracting/hooks/useContractingStep";
import React from "react";
import { useSelector } from "react-redux";
import IAppState from "infrastructure/store/IAppState";
import ContractingState from "infrastructure/store/contracting/ContractingState";
import { useForm } from "features/shared/forms/hooks/useForm";
import ConsentsSubForm from "features/contracting/components/overview/ConsentsSubForm";
import { UserEnumDTO } from "features/shared/enums/dynamic/UserEnumDTO";
import ContractingSummary from "features/contracting/components/overview/summary/ContractingSummary";
import ContractingStepConfiguration from "features/contracting/models/ContractingStepConfiguration";
import { loadModule } from "features/shared/helpers/modules";
import OtherInfoSubForm from "features/contracting/components/overview/OtherInfoSubForm";
import { overviewFormValidations } from "./overviewFormValidation";
import CustomerState from "infrastructure/store/customer/CustomerState";

const contractingSteps = loadModule<ContractingStepConfiguration[]>(
  "contracting/contractingSteps.json"
);

const OverviewFormSection = (props: ContractingStepFormProps) => {
  // store
  const contracting = useSelector<IAppState, ContractingState>(
    (store) => store.contracting
  ).progress;

  const stepData = contracting.steps[props.actualStep.component];

  const configuration = useSelector<IAppState, ContractingState>(
    (store) => store.contracting
  ).configuration;

  const consents: UserEnumDTO[] = configuration.consents!;

  // store
    const customer = useSelector<IAppState, CustomerState>(
      (store) => store.customer
    ).customer;

  // form hook
  const formHandler = useForm({
    initialValues: stepData.values ?? undefined,
    initialValidations: overviewFormValidations(customer.customerNumber)
  });

  const { values, valideteForm } = { ...formHandler };

  // form-step hook
  const { onPrevClick, onFinishClick } = useContractingStep({
    ...props,
    formValues: values,
    validateForm: valideteForm,
  });

  // render
  return (
    <div>
      <ContractingSummary
        contracting={contracting}
        steps={contractingSteps}
        configuration={configuration}
      />

      <OtherInfoSubForm formHandler={formHandler} />

      <ConsentsSubForm consents={consents} formHandler={formHandler} />

      <ContractingFooter
        onPrevClick={onPrevClick}
        onFinishClick={() => onFinishClick(props.enableBackToLoginBtn)}
      />
    </div>
  );
};

export default OverviewFormSection;
